import { DateTime } from 'luxon';

export const getTimezoneLocalISO = ({ isoDate, timezone }) =>
  DateTime.fromISO(isoDate, {
    zone: timezone,
  })
    .toUTC(undefined, { keepLocalTime: true })
    .toISO();
